import { AvatarGroup, Stack, TableColumn } from '@ff-it/ui';
import type { GenericTask } from './types';
import { CommentBadge } from 'modules/comments';
import { ContentObjectWidget } from 'components/widgets/ContentObjectWidget';
import { Link } from 'react-router-dom';
import { ContentPopoverButton } from './ContentPopoverButton';
import { UserAvatar } from 'components/UserAvatar';
import { formatDateTime } from 'utilities';
import { DeadlineDate } from 'components/DeadlineDate';

export const name: TableColumn<GenericTask> = {
  content: 'Name',
  key: 'name',
  render: ({ name, url, content }) => (
    <Stack direction="horizontal" align="center" my="-1" justify="between">
      <Link to={url}>{name}</Link>
      <ContentPopoverButton content={content} />
    </Stack>
  ),
};

export const topic: TableColumn<GenericTask> = {
  key: 'topic',
  width: '46px',
  render: ({ topic, url }) => (
    <CommentBadge objectKey={topic.object_key} count={topic.count}>
      <Link to={url} />
    </CommentBadge>
  ),
};

export const context: TableColumn<GenericTask> = {
  content: 'Context',
  key: 'object',
  render: ({ object }) => <ContentObjectWidget content_object={object} />,
};

export const author: TableColumn<GenericTask> = {
  content: 'Author',
  key: 'created_by',
  width: '100px',
  render: ({ created_by }) => <UserAvatar user={created_by} size="xs" />,
};

export const created: TableColumn<GenericTask> = {
  content: 'Created',
  key: 'created_at',
  width: '140px',
  render: ({ created_at }) => formatDateTime(created_at),
};

export const dueDate: TableColumn<GenericTask> = {
  content: 'Due date',
  key: 'due_date',
  width: '120px',
  render: ({ due_date }) => (due_date ? <DeadlineDate deadline={due_date} /> : '-'),
};

export const assignees: TableColumn<GenericTask> = {
  content: 'Assignees',
  key: 'assignees',
  width: '160px',
  render: ({ assignees }) => (
    <AvatarGroup size="xs">
      {assignees.map((u) => (
        <UserAvatar user={u} key={u.id} />
      ))}
    </AvatarGroup>
  ),
};
